import { Geography } from '@rbilabs/common';
import { differenceInMinutes } from 'date-fns';
import { useIntl } from 'react-intl';

import { IStore } from '@rbi-ctg/store';
import { IRestaurantNode } from 'generated/rbi-graphql';
import { useGeolocation } from 'state/geolocation';
import { useLocale } from 'state/intl';
import { StoreProxy } from 'state/store';
import { readableDistanceFromStore } from 'utils/restaurant';

interface UserDistanceTextOptions {
  restaurant: IRestaurantNode | IStore | StoreProxy;
  shouldUseUserCoordinatesIfAvailable?: boolean;
}

const MAX_TIME_WITHOUT_UPDATES_IN_MIN = 30;

export const useDistanceText = ({
  restaurant: { latitude, longitude },
  shouldUseUserCoordinatesIfAvailable = false,
}: UserDistanceTextOptions) => {
  const { activeCoordinates, userCoordinates, lastUserCoordinateTimestamp } = useGeolocation();
  const { formatMessage } = useIntl();
  const { region } = useLocale();
  const lastLocationTimeDiff = differenceInMinutes(
    lastUserCoordinateTimestamp ?? Date.now(),
    Date.now()
  );

  let distanceText = '';
  const coordinates = shouldUseUserCoordinatesIfAvailable
    ? userCoordinates ?? activeCoordinates
    : activeCoordinates;

  if (
    coordinates &&
    latitude &&
    longitude &&
    lastLocationTimeDiff < MAX_TIME_WITHOUT_UPDATES_IN_MIN
  ) {
    const distance = Geography.coordinateDistance(
      { latitude: coordinates.lat, longitude: coordinates.lng },
      {
        latitude,
        longitude,
      }
    );
    distanceText = readableDistanceFromStore(distance, region, formatMessage);
  }

  return distanceText;
};
